import { makeAutoObservable } from 'mobx';

/**
 * Что из оболочки кабинета показывать на текущем экране.
 *
 * Cockpit R3 занимает всю ширину: боковое меню на нём заменено
 * выпадающим (решение 28.10.2026). Экран выставляет флаг на время
 * своей жизни и снимает при уходе — остальные страницы не меняются.
 */
class ShellChrome {
  sidebarHidden = false;
  /** Верхняя шапка кабинета; её контролы экран ставит к себе. */
  headerHidden = false;
  /**
   * Оболочка R3 во всех разделах (пилот, флаг cockpit-r3.json).
   * Разделы по нему показывают заголовок и вид «Сегодня» (R3Page).
   */
  r3 = false;
  /** Флаг пилота уже прочитан. До этого страницы с двумя видами не решают, куда вести. */
  r3Ready = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  hideSidebar(hidden: boolean) {
    this.sidebarHidden = hidden;
  }

  hideHeader(hidden: boolean) {
    this.headerHidden = hidden;
  }

  /** null — флаг ещё читается. */
  setR3(on: boolean | null) {
    this.r3 = on === true;
    this.r3Ready = on !== null;
  }
}

export const shellChrome = new ShellChrome();
